import React from "react";
import Hero from "@/components/organisms/Hero";
import AmenityCard from "../organisms/AmenityCard";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Grid } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/grid";


const AmenitiesGrid = ({t, amenities }) => {
  return (
    <section className="mt-8 mb-16">
      <Hero
        title={{
          text: t("rooms:amenities_details.title"),
          className: "hero-title mb-0 md:text-left text-3xl md:text-5xl",
        }}
        text={{
          text: t("rooms:amenities_details.subtitle"),
          className: "section-subtitle text-center lg:text-left uppercase",
        }}
        paragraphs={{
          list: t("rooms:amenities_details.paragraphs", {returnObjects:true}),
          className:
          "hero-text mb-8 text-center md:text-left text-sm md:text-base leading-[28px] lg:leading-[32px]",
        }}
        styles={{
          heroContainer: "pt-6 md:pt-12 md:pb-0",
          textContainer:
            "col-span-12 md:col-start-2 md:col-span-10 order-1 uppercase",
          titleContainer: "col-span-12 md:col-start-2 md:col-span-10 order-2",
          paragraphsContainer:
            "col-span-12 md:col-start-2 md:col-span-10 order-3",
        }}
      />
      <div className="base-container">
        <div className="hidden lg:grid md:grid-cols-3 lg:grid-cols-4 w-fit m-auto gap-8">
          {amenities.length !== 0 &&
            amenities.map((amenity, key) => {
              return <AmenityCard key={key} amenity={amenity} />;
            })}
        </div>
        <div className="block lg:hidden">
          <Swiper
            pagination={{
              clickable: true,
            }}
            slidesPerGroup={2}
            slidesPerView={2}
            modules={[Pagination, Grid]}
            style={{
              "--swiper-navigation-color": "#00205C",
              "--swiper-theme-color": "#00205C"
            }}
            grid={{
              rows: 2,
              columns:2,
              fill: "row",
            }}
          >
            {amenities.map((amenity, key) => {
              return (
                <SwiperSlide key={"slide-" + key} className="my-6">
                  <AmenityCard key={key} amenity={amenity} className="mx-auto flex flex-col items-center text-center" />
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default AmenitiesGrid;
